import Component from '../core/Component';

export default class Tabs extends Component {

    constructor($element) {
        super($element);
        this.$anchors = this.$element.find('[data-component-ref="anchors"]');
        this.$content = this.$element.find('[data-component-ref="content"]');
        this.$wrap = this.$element.find('[data-component-ref="wrap"]');
    }

    prepare() {
        this.setWrapHeight(false);

        this.$anchors.on('click', 'a', event => {
            event.preventDefault();
            $(event.currentTarget).parent().addClass('is-active').siblings().removeClass('is-active');
            $(event.currentTarget.hash).fadeIn(250).siblings().fadeOut(250, () => setTimeout(() => this.setWrapHeight(true), 0));
        });

        this.$wrap.on('setWrapHeight', () => this.setWrapHeight());
    }

    setWrapHeight(animate = false) {
        if (animate) {
            this.$wrap.animate({
                height: this.$content.filter(':visible').outerHeight() + 'px'
            }, 250);
        } else {
            this.$wrap.css('height', this.$content.filter(':visible').outerHeight());
        }
    }
}


// WEBPACK FOOTER //
// ./components/Tabs.js